import type { PopupBrandFont } from '@onetext/api';
import { POPUP_FONT_PROVIDER } from '@onetext/api';

export const brandFont : PopupBrandFont = {
    default: {
        fontFamily:   'SatoshiBold-normal-700',
        fontProvider: POPUP_FONT_PROVIDER.BROWSER
    },
    options: []
};
